import firebase from "firebase/compat/app";
import {db, storage} from "../firebase";
import {getUid} from "./auth";
import {Collections} from "./collections";
import {bgItemTypeToPath, BgItemTypeToPathI} from "../db/models/const";
import {MissingType} from "../db/models/extra";
import {RoleEnum} from "../db/models/role";

export const deleteFile = (
    storagePath: string,
    docField: string,
    docId: string
) => {
    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    const path = storagePath;

    return storage
        .ref(path)
        .delete()
        .then(() => {
            return db
                .doc(docId)
                .update({[docField]: firebase.firestore.FieldValue.delete()});
        });
};

export const deleteFileWithExtension = (
    storagePath: string,
    docField: string,
    docId: string
) => {
    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    const fieldPath = new firebase.firestore.FieldPath(...docField);

    return storage
        .ref(storagePath)
        .delete()
        .then(() => {
            return db
                .doc(docId)
                .update(fieldPath, firebase.firestore.FieldValue.delete());
        });
};

export const uploadFile = (
    file: MissingType,
    storagePath: string,
    docField: string,
    docId: string
) => {
    if (!file) return;

    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    const uploadTask = storage.ref(storagePath).put(file);
    return uploadTask.on(
        "state_changed",
        (snapshot) => {
            // const progress = Math.round(
            // 	(snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // );
        },
        (error) => {
            console.error(error);
        },
        () => {
            storage
                .ref(storagePath)
                .getDownloadURL()
                .then(async (url) => {
                    await db.doc(docId).update(docField, url);
                })
                .catch((error) => console.error(error));
        }
    );
};

export const uploadFileWithExtension = (
    file: MissingType,
    storagePath: string,
    docField: string,
    docId: string,
    onComplete: Function
) => {
    if (!file) return;

    const uid = getUid();
    if (!uid) return Promise.reject("no uid");

    const uploadTask = storage.ref(storagePath).put(file);
    return uploadTask.on(
        "state_changed",
        (snapshot) => {
            // const progress = Math.round(
            // 	(snapshot.bytesTransferred / snapshot.totalBytes) * 100
            // );
        },
        (error) => {
            console.error(error);
        },
        () => {
            storage
                .ref(storagePath)
                .getDownloadURL()
                .then(async (url) => {
                    const fieldPath = new firebase.firestore.FieldPath(...docField);
                    await db.doc(docId).update(fieldPath, url);
                    if (onComplete) onComplete();
                })
                .catch((error) => console.error(error));
        }
    );
};

// export const downloadFile = (url, onLoad) => {
// 	console.log("start download block")
// 	var xhr = new XMLHttpRequest();
// 	xhr.responseType = 'blob';
// 	xhr.onload = onLoad(xhr);
// 	xhr.open('GET', url);
// 	xhr.send();
// 	console.log("start send request")
// };

export const updateStudentBgItem = (
    docId: string,
    type: keyof BgItemTypeToPathI,
    item: MissingType,
    isNewItem: boolean
) => {
    if (!docId || !type || !item || isNewItem === null)
        return Promise.reject("Bad params");

    const uid = getUid();

    let itemId;
    if (isNewItem) {
        itemId = Math.random().toString(36).substr(2, 9);
        item.id = itemId;
    } else {
        itemId = item.id;
    }

    return db.doc(`${Collections.STUDENT_CVS}/${uid}`).set(
        {
            id: docId,
            bg: {
                [bgItemTypeToPath[type]]: {
                    [itemId]: item,
                },
            },
        },
        {merge: true}
    );
};

export const addRmCompetence = (docId: string, competence: MissingType) => {
    if (!docId || !competence) return Promise.reject("Bad params");

    let itemId = Math.random().toString(36).substr(2, 9);
    competence.id = itemId;

    return db.doc(`${Collections.COMPANY_RMS}/${docId}`).set(
        {
            id: docId,
            bg: {
                competences: {
                    [itemId]: competence,
                },
            },
        },
        {merge: true}
    );
};

export const updateRmCompetence = (docId: string, competence: MissingType) => {
    if (!docId || !competence) return Promise.reject("Bad params");

    const itemId = competence.id;

    return db
        .doc(`${Collections.COMPANY_RMS}/${docId}`)
        .update(`bg.competences.${itemId}`, competence);
};

export const addRmLanguage = (docId: string, language: MissingType) => {
    if (!docId || !language) return Promise.reject("Bad params");

    let itemId = Math.random().toString(36).substr(2, 9);
    language.id = itemId;

    return db.doc(`${Collections.COMPANY_RMS}/${docId}`).set(
        {
            id: docId,
            bg: {
                languages: {
                    [itemId]: language,
                },
            },
        },
        {merge: true}
    );
};

export const updateRmLanguage = (docId: string, language: MissingType) => {
    if (!docId || !language) return Promise.reject("Bad params");

    const itemId = language.id;

    return db
        .doc(`${Collections.COMPANY_RMS}/${docId}`)
        .update(`bg.languages.${itemId}`, language);
};

export const updateRmBgItem = (
    docId: string,
    type: keyof BgItemTypeToPathI,
    item: MissingType,
    isNewItem: boolean
) => {
    if (!docId || !type || !item || isNewItem === null)
        return Promise.reject("Bad params");

    let itemId;
    if (isNewItem) {
        itemId = Math.random().toString(36).substr(2, 9);
        item.id = itemId;
    } else {
        itemId = item.id;
    }

    return db.doc(`${Collections.COMPANY_RMS}/${docId}`).set(
        {
            id: docId,
            bg: {
                [bgItemTypeToPath[type]]: {
                    [itemId]: item,
                },
            },
        },
        {merge: true}
    );
};

export const deleteBgItem = (
    docId: string,
    itemId: string,
    itemType: keyof BgItemTypeToPathI,
    role: RoleEnum
) => {
    let docPath: string = "";
    const uid = getUid();
    if (role === "student") docPath = `${Collections.STUDENT_CVS}/${uid}`;
    if (role === "company") docPath = `${Collections.COMPANY_RMS}/${docId}`;
    return db.doc(docPath).set(
        {
            bg: {
                [bgItemTypeToPath[itemType]]: {
                    [itemId]: firebase.firestore.FieldValue.delete(),
                },
            },
        },
        {merge: true}
    );
};

export const getMaintenanceListener = (observer: MissingType) => {
    return db
        .collection(Collections.MANAGEMENT)
        .doc("maintenance")
        .onSnapshot(observer);
};
